import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, MessageBar, MessageBarBody, MessageBarTitle, Spinner, Tooltip } from "@fluentui/react-components";
import { Delete16Filled } from "@fluentui/react-icons";
import { useEffect, useState } from "react";
import IDeletePasswordProps from "./IDeletePasswordProps";
import passwordService from "../../services/passwordService";
import Status from "../../enums/Status";
import useStyleUtils from "../../utilities/styles";
import { useTranslation } from "react-i18next";
import { mergeStyles } from "@fluentui/merge-styles";

const DeleteError = () => {
    const { t } = useTranslation();
    
    return (
        <MessageBar intent="error">
            <MessageBarBody>
                <MessageBarTitle>
                    {t("general.error")}
                </MessageBarTitle>
                {t("passwords.errors.deletePassword")}
            </MessageBarBody>
        </MessageBar>
    );
};

export default function DeletePassword(props: IDeletePasswordProps) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState<Status>(Status.NEUTRAL);

    const styles = useStyleUtils();

    const triggerStyles = mergeStyles({
        color: "red"
    });

    useEffect(() => {
        if (open) {
            setStatus(Status.NEUTRAL);
        }
    }, [open, props.passwordId]);
    
    const handleSubmit = () => {
        setStatus(Status.DELETING);
        passwordService.deletePassword(props.passwordId)
            .then(() => {
                props.onDelete();
                setOpen(false);
            })
          .catch(_ => setStatus(Status.DELETE_ERROR));
    };

    const isReadonly = [Status.DELETING, Status.DELETE_SUCCESS].includes(status);
    
    return (
        <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
            <DialogTrigger disableButtonEnhancement>
                <Tooltip content={t("passwords.titles.delete")} relationship='label'>
                    <Button icon={<Delete16Filled className={triggerStyles} />} />
                </Tooltip>
            </DialogTrigger>
            <DialogSurface>
                <DialogTitle>{t("passwords.titles.delete")}</DialogTitle>
                <DialogBody>
                    <DialogContent>
                        {
                            status !== Status.DELETE_SUCCESS &&
                            <p>
                                {t("passwords.delete.message")}
                            </p>
                        }
                        {
                            status === Status.DELETE_ERROR &&
                            <DeleteError />
                        }
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="primary" disabled={isReadonly}>
                                {t("general.no")}
                            </Button>
                        </DialogTrigger>
                        <Button appearance="secondary" onClick={handleSubmit} disabled={isReadonly}>
                            {
                                isReadonly && <Spinner size="tiny" className={styles.mr2} />
                            }
                            {t("general.yes")}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}